import React, { useState, useEffect } from "react";
import { useFormCtx } from "./FormContext";
import dateFormat from "dateformat";
import Navbar from "./components/Navbar";
import Button from "./components/Button";
import Transition from "./components/Transition";
import NotFoundSection from "./components/NotFoundSection";
import useMediaQuery from "./hooks/useMediaQuery";
import InfoMessage from "./components/InfoMessage";
import ImageCardAnimation from "./components/ImageCardAnimation";
import * as Const from "./_Const";
import * as Helper from "./_Helper";
import useMqttClient from "./hooks/useMqttClient";
import useSimpleMachine from "./hooks/useSimpleMachine";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";
import Dialog from "./components/Dialog";
import * as TerminalAppService from "./services/data/TerminalAppService";
import * as PatientService from "./services/data/PatientService";
import useScreenType from "./hooks/useScreenType";
import HiddenMenuBar from "./components/HiddenMenuBar";
import ScreenSaver from "./components/ScreenSaver";

// 1. Definice mapy stavů a přechodů
const STATE_IDLE = "STATE_IDLE";
const STATE_CHANGE_DOCUMENT_OPENED = "STATE_CHANGE_DOCUMENT_OPENED";
const STATE_DATA_PROCCESSING = "STATE_DATA_PROCCESSING";
const STATE_PHOTO_CREATED = "STATE_PHOTO_CREATED";
const STATE_PHOTO_CAPTURE_ERROR = "STATE_PHOTO_CAPTURE_ERROR";
const STATE_CARD_REMOVED_TOO_EARLY = "STATE_CARD_REMOVED_TOO_EARLY";
const STATE_API_PATIENT_REGISTRATION = "STATE_API_PATIENT_REGISTRATION";
const STATE_API_PATIENT_REGISTRATION_ERROR = "STATE_API_PATIENT_REGISTRATION_ERROR";
const STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR = "STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR";
const STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR = "STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR";
const STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_ID = "STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_OP";
const STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_DL = "STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_DL";

const STATE_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED = "STATE_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED";
const STATE_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED = "STATE_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED";

const STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR = "STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR";
const STATE_API_PATIENT_REGISTRATION_SUCCES = "STATE_API_PATIENT_REGISTRATION_SUCCES";
const STATE_GET_PHOTO = "STATE_GET_PHOTO";
const STATE_GET_PHOTO_ERROR = "STATE_GET_PHOTO_ERROR";

const STATE_RUNING_WITHOUT_CARD = "STATE_RUNING_WITHOUT_CARD";

const ACTION_RUN_WITHOUT_CARD = "ACTION_RUN_WITHOUT_CARD";
const ACTION_INSERT = "ACTION_INSERT";
const ACTION_ERROR = "ACTION_ERROR";
const ACTION_CARD_REMOVED_TOO_EARLY_ERROR = "ACTION_CARD_REMOVED_TOO_EARLY_ERROR";
const ACTION_RESET = "ACTION_RESET";
const ACTION_SUCCESS = "ACTION_SUCCESS";
const ACTION_CARD_REMOVED = "ACTION_CARD_REMOVED";
const ACTION_CHANGE_DOCUMENT_OPEN = "ACTION_CHANGE_DOCUMENT_OPEN";
const ACTION_CHANGE_DOCUMENT_CLOSE = "ACTION_CHANGE_DOCUMENT_CLOSE";
const ACTION_API_REGISTER_PATIENT = "ACTION_API_REGISTER_PATIENT";
const ACTION_API_REGISTER_PATIENT_ERROR = "ACTION_API_REGISTER_PATIENT_ERROR";
const ACTION_API_REGISTER_PATIENT_SUCCES = "ACTION_API_REGISTER_PATIENT_SUCCES";
const ACTION_API_REGISTER_PATIENT_CONFLICT_409_ERROR = "ACTION_API_REGISTER_PATIENT_CONFLICT_409_ERROR";
const ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR = "ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR";
const ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_ID = "ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_ID";
const ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_DL = "ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_DL";

const ACTION_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED = "ACTION_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED";
const ACTION_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED = "ACTION_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED";

const ACTION_API_REGISTER_PATIENT_CONNECTION_ERROR = "ACTION_API_REGISTER_PATIENT_CONNECTION_ERROR";

const ACTION_GET_PHOTO = "ACTION_GET_PHOTO";
const ACTION_GET_PHOTO_ERROR = "ACTION_GET_PHOTO_ERROR";

const insert_card_photo_capture_test = "Kamera TEST - POVOLEN";
const insert_card_title = "Registrace do systému";
const insert_card_registration_without_card = "Probíhá registrace do systému bez průkazu totožnosti";
const insert_card_progress_subtitle = "Průkaz totožnosti úspěšně vložen";
const insert_card_loading_data_success = "Průkaz totožnosti úspěšně načten";
const insert_card_do_not_remove_card = "Nevyndavejte průkaz totožnosti!";
const insert_card_not_have_card_progress_subtitle = "Zpracovávám váš požadavek...";

const e_post_patient_retry_failed_dialog_title = "Chyba připojení k internetu";
const e_post_patient_retry_failed_dialog_desc = "Nastala chyba při registraci do systému.\n\nOpakujte prosím akci.";

const e_post_patient_driving_licence_diabled_title = "Nelze vkládat řidičský průkaz";
const e_post_patient_driving_licence_diabled_desc = "Registrace pomocí řidičský průkazu není na tomto zařízení povolena.\n\nPoužijte jiný průkaz totožnosti.";

const e_post_patient_id_diabled_title = "Nelze vkládat občanský průkaz";
const e_post_patient_id_diabled_desc = "Registrace pomocí občanského průkazu není na tomto zařízení povolena.\n\nPoužijte jiný průkaz totožnosti.";

const e_post_patient_406_dialog_driving_licence_title = "Otočte Řidičský průkaz";
const e_post_patient_406_dialog_driving_licence_desc =
  "Vložte Řidičský průkaz tak, aby jste fotografii na ŘP drželi v prstech a směřovala směrem vzhůru a ven z terminálu a příjmení, jméno, datum narození, rodné číslo a ostatní údaje směřovaly vzhůru a dovnitř do terminálu.";

const e_post_patient_406_dialog_id_title = "Otočte Občanský průkaz";
const e_post_patient_406_dialog_id_desc =
  "Vložte Občanský průkaz tak, aby jste fotografii na OP drželi v prstech a směřovala směrem dolů a ven z terminálu a čip na OP směřoval vzhůru a dovnitř do terminálu.";

const e_post_patient_409_dialog_title = "Již jste v systému";
const e_post_patient_409_dialog_desc = "Posaďte se prosím do čekárny\na vyčkejte na zavolání";

const e_post_patient_406_dialog_title = "Otočte průkaz pojištěnce";
const e_post_patient_406_dialog_desc =
  "Vložte průkaz pojištěnce tak, aby jméno, příjmení, datum narození, rodné číslo a ostatní údaje směřovaly vzhůru a dovnitř do terminálu.";

const e_get_photo_dialog_title = "Chyba při čtení průkazu";
const e_get_photo_dialog_desc = "Nastala chyba při čtení dat z průkazu.\n\nOpakujte prosím akci.";

const e_insert_card_removed_before_end_title = "Průkaz totožnosti vyjmut";
const e_insert_card_removed_before_end = "Průkaz totožnosti byl vyjmut dříve než bylo dokončeno načítání dat.\n\nOpakujte prosím akci.";
const dialog_footer = "Pokračujte kliknutím...";

const CardTerminalMachine = {
  // Stav 'IDLE': Čekání na vložení karty
  [STATE_IDLE]: {
    [ACTION_RUN_WITHOUT_CARD]: STATE_RUNING_WITHOUT_CARD,
    [ACTION_INSERT]: STATE_DATA_PROCCESSING,
    [ACTION_CHANGE_DOCUMENT_OPEN]: STATE_CHANGE_DOCUMENT_OPENED,
  },
  [STATE_CHANGE_DOCUMENT_OPENED]: {
    [ACTION_CHANGE_DOCUMENT_CLOSE]: STATE_IDLE,
  },
  [STATE_RUNING_WITHOUT_CARD]: {
    [ACTION_API_REGISTER_PATIENT_ERROR]: STATE_API_PATIENT_REGISTRATION_ERROR,
    [ACTION_API_REGISTER_PATIENT_SUCCES]: STATE_API_PATIENT_REGISTRATION_SUCCES,
    [ACTION_API_REGISTER_PATIENT_CONFLICT_409_ERROR]: STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR,
    [ACTION_API_REGISTER_PATIENT_CONNECTION_ERROR]: STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR,
  },
  [STATE_DATA_PROCCESSING]: {
    //[ACTION_SUCCESS]: STATE_GET_PHOTO,
    [ACTION_GET_PHOTO_ERROR]: STATE_GET_PHOTO_ERROR,
    [ACTION_API_REGISTER_PATIENT_ERROR]: STATE_API_PATIENT_REGISTRATION_ERROR,
    [ACTION_API_REGISTER_PATIENT_SUCCES]: STATE_API_PATIENT_REGISTRATION_SUCCES,
    [ACTION_ERROR]: STATE_PHOTO_CAPTURE_ERROR,
    [ACTION_CARD_REMOVED_TOO_EARLY_ERROR]: STATE_CARD_REMOVED_TOO_EARLY,
    [ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR]: STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR,
    [ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_DL]: STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_DL,
    [ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_ID]: STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_ID,
    [ACTION_API_REGISTER_PATIENT_CONFLICT_409_ERROR]: STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR,
    [ACTION_API_REGISTER_PATIENT_CONNECTION_ERROR]: STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR,
    [ACTION_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED]: STATE_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED,
    [ACTION_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED]: STATE_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED,
  },
  [STATE_GET_PHOTO_ERROR]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_ID]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_DL]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_ERROR]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_API_PATIENT_REGISTRATION_SUCCES]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  [STATE_PHOTO_CAPTURE_ERROR]: {
    [ACTION_RESET]: STATE_IDLE,
  },
  // [STATE_SHOW_ERROR]: {
  //   [ACTION_RESET]: STATE_IDLE,
  // },
  [STATE_CARD_REMOVED_TOO_EARLY]: {
    [ACTION_RESET]: STATE_IDLE,
  },
};

function PageInsertCard() {
  const {
    getPageData,
    beep,
    axiosTerminalAppInstance,
    instance,
    getUid,
    terminalSettingsState,
    navigateNext,
    validate,
    setData,
    isPhotoCaptureTestEnabled,
    setBrightnessTo,
  } = useFormCtx();

  const [isScreenSaverActive, setScreenSaverActive] = useState(false);
  const [isIdBtnPressed, setIsIdBtnPressed] = useState(false);
  const [isInsuranceCardBtnPressed, setIsInsuranceCardBtnPressed] = useState(false);
  const [isDlBtnPressed, setIsDlBtnPressed] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [docType, setDocType] = useState(Const.DOC_TYPE_INSURANCE_CARD);

  // Použití hooku: Počáteční stav je 'IDLE'
  const [state, send, reset] = useSimpleMachine(STATE_IDLE, CardTerminalMachine);

  const { isConnected, messages, publish, lastMessage } = useMqttClient(Const.TERMINAL_APP_SERVICE_WEB_SOCKET_URL, Const.TOPIC_MQTTT_LOCAL);
  const [lastProcessedMessage, setLastProcessedMessage] = useState(null);
  const [lastProcessedState, setLastProcessedState] = useState(null);
  const screenType = useScreenType();

  //const textClass = isRpiScreen ? "text-4xl h-20" : "h-10";

  const index = Const.REG_RPI_INSERT_CARD_INDEX;
  const page = getPageData(index);
  //const apiPageData = getApiPage(Const.PAGE_TERMINAL_ID_INSERT_CARD);

  const isTerminal = Const.isTerminal();

  useEffect(() => {
    function scopedLoadData() {
      initStateAfterCaptureOrError();
    }

    scopedLoadData();

    //cleanup before unload - pri opusteni page insert zakazu card reader
    return () => {
      console.log("PageCardInsert - before unload");
      setCardReaderTo(Const.STATE_DISABLED, "scopedLoadData return");
    };
  }, []);

  //volat jen kdyz se zmeni state nebo lastMessage a je zarovne proveden onload
  useEffect(() => {
    if (lastMessage) {
      //zavolam to abych stanovil state
      handleMqttMessage(lastMessage);
    }

    if (state) {
      handleStateChange(state);
    }
  }, [state, lastMessage]);

  const docGridColumns = terminalSettingsState.isDrivingLicenceEnabled && terminalSettingsState.isIDCardEnabled ? "grid-cols-3" : "grid-cols-2";

  const title = state === STATE_CHANGE_DOCUMENT_OPENED ? "Vyberte průkaz pro registraci" : page.title;
  const subtitle = state === STATE_CHANGE_DOCUMENT_OPENED ? "kliknutím na ikonu průkazu změníte průkaz totožnosti pro registraci do systému" : ""; //page.subtitle;
  const showSubtitle = false;

  //console.log(title, subtitle);

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "debug-state-title":
          css = "text-sm";
          break;
        case "photo-capture-test-title":
          css = "text-sm";
          break;
        case "idle-subtitle":
          css = "text-3xl mt-4";
          break;
        case "idle-doc-button":
          css = "h-22 text-md max-w-44 pr-8";
          break;
        case "idle-no-card-button":
          css = "h-[72px] min-w-52 text-xl";
          break;
        case "idle-animation-div":
          css = "mt-4";
          break;
        case "doc-close-button":
          css = "h-[72px] min-w-52 text-xl";
          break;
        case "doc-h1":
          css = "text-lg mt-4";
          break;
        case "doc-btn-grid":
          css = "mt-0 mx-0 gap-2";
          break;
        case "doc-btn-image":
          css = "h-36";
          break;
        case "doc-p-title":
          css = " text-lg mt-1";
          break;
        case "doc-p-subtitle":
          css = "text-lg -mt-1";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "debug-state-title":
          css = "";
          break;
        case "photo-capture-test-title":
          css = "";
          break;
        case "idle-subtitle":
          css = "text-5xl mt-8";
          break;
        case "idle-doc-button":
          css = "h-28 text-xl max-w-56 pr-8";
          break;
        case "idle-no-card-button":
          css = "h-20  text-3xl";
          break;
        case "idle-animation-div":
          css = "mt-8";
          break;
        case "doc-close-button":
          css = "h-20 min-w-72 text-3xl";
          break;
        case "doc-h1":
          css = "text-3xl mt-8";
          break;
        case "doc-btn-grid":
          css = "mt-2 mx-4 gap-4";
          break;
        case "doc-btn-image":
          css = "h-72";
          break;
        case "doc-p-title":
          css = " text-3xl mt-2";
          break;
        case "doc-p-subtitle":
          css = "text-3xl";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "debug-state-title":
          css = "";
          break;
        case "photo-capture-test-title":
          css = "";
          break;
        case "idle-subtitle":
          css = "text-5xl mt-8";
          break;
        case "idle-doc-button":
          css = "h-28 text-xl max-w-56 pr-8";
          break;
        case "idle-no-card-button":
          css = "h-20  text-3xl";
          break;
        case "idle-animation-div":
          css = "mt-8";
          break;
        case "doc-close-button":
          css = "h-20 min-w-72 text-3xl";
          break;
        case "doc-h1":
          css = "text-3xl mt-8";
          break;
        case "doc-btn-grid":
          css = "mt-8 mx-4 gap-4";
          break;
        case "doc-btn-image":
          css = "h-80";
          break;
        case "doc-p-title":
          css = " text-3xl mt-4";
          break;
        case "doc-p-subtitle":
          css = "text-3xl";
          break;
      }
    }
    // console.log(what, screenType, css);

    return css;
  }

  function handleSetDocType(id, playBeep = true, showActive = true) {
    if (showActive) {
      switch (id) {
        case Const.DOC_TYPE_ID:
          setIsIdBtnPressed(true);
          break;
        case Const.DOC_TYPE_DRIVER_LICENCE:
          setIsDlBtnPressed(true);
          break;
        case Const.DOC_TYPE_INSURANCE_CARD:
          setIsInsuranceCardBtnPressed(true);
          break;
      }
    }

    if (playBeep) {
      beep();
    }
    //pockat na konec animace
    setTimeout(() => {
      setDocType(id);
      handleSend(ACTION_CHANGE_DOCUMENT_CLOSE, false);

      setCardReaderTo(Const.STATE_ENABLED, "handleSetDocType");

      if (showActive) {
        switch (id) {
          case Const.DOC_TYPE_ID:
            setIsIdBtnPressed(false);
            break;
          case Const.DOC_TYPE_DRIVER_LICENCE:
            setIsDlBtnPressed(false);
            break;
          case Const.DOC_TYPE_INSURANCE_CARD:
            setIsInsuranceCardBtnPressed(false);
            break;
        }
      }
    }, 200);
  }

  function openChangeDocument() {
    handleSend(ACTION_CHANGE_DOCUMENT_OPEN, false);
    setCardReaderTo(Const.STATE_DISABLED, "openChangeDocument");
  }

  async function initStateAfterCaptureOrError() {
    send(ACTION_RESET);
    await setCardReaderTo(Const.STATE_ENABLED, "initStateAfterCaptureOrError");
  }

  async function runPatientWihhoutCardClicked() {
    handleSend(ACTION_RUN_WITHOUT_CARD, false);
    setData("isWithoutCard", true);
    //o zakazani setCardReaderTo(STATE_DISABLED) se postarta clean up useEffect()[]
    //await setCardReaderTo(STATE_DISABLED);
  }

  async function registerPatient(image, isWithoutCard) {
    console.log(`${new Date().toISOString()} patient registration isWithouCard: ${isWithoutCard}, state: ${state}`);
    //sendDelayAction(ACTION_API_REGISTER_PATIENT, 2000);

    try {
      const response = await PatientService.registerV2(instance, getUid(), setViewToModel(image, isWithoutCard));
      console.log(response);

      //nastaveni da do setState pro pouziti dale
      setData("pid", response?.data?.ID, "identification", response?.data?.Identification, null, null, false);
      handleSend(ACTION_API_REGISTER_PATIENT_SUCCES, false);
      //initStateAfterCaptureOrError();
      //pmoci validate s dostanu po zvalidovani na dlsi stranku
      validate(index);
    } catch (ex) {
      let isErrorHandled = false;
      console.log(ex, ex?.response);
      if (ex?.response?.status === 400) {
        //navigateToErrorPage(Const.PAGE_ERROR_NOT_FOUND);
        //isErrorHandled = true;
      } else if (ex?.response?.status === 406) {
        isErrorHandled = true;
        //otocit prukaz
        const respDocType = ex?.response?.data?.DocumentType;
        console.log("error docType", respDocType);
        switch (respDocType) {
          case Const.DOC_TYPE_ID:
            if (terminalSettingsState.isIDCardEnabled) {
              handleSend(ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_ID);
            } else {
              handleSend(ACTION_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED);
            }
            break;
          case Const.DOC_TYPE_DRIVER_LICENCE:
            if (terminalSettingsState.isDrivingLicenceEnabled) {
              handleSend(ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR_DL);
            } else {
              handleSend(ACTION_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED);
            }

            break;
          default:
            handleSend(ACTION_API_REGISTER_PATIENT_ROTATION_406_ERROR);
            break;
        }
      } else if (ex?.response?.status === 409) {
        isErrorHandled = true;
        handleSend(ACTION_API_REGISTER_PATIENT_CONFLICT_409_ERROR);
      } else if (ex?.code === "ERR_NETWORK") {
        isErrorHandled = true;
        handleSend(ACTION_API_REGISTER_PATIENT_CONNECTION_ERROR);
      }

      if (!isErrorHandled) {
        handleSend(ACTION_API_REGISTER_PATIENT_ERROR);
      }
    } finally {
      //setTaskRunning(false);
      //nastartuj timer
      //resetTerminalSummaryTimer();
    }
  }

  function setViewToModel(image, isWithoutCard) {
    const identificaton = Helper.getRandomIdentificator(); //"A01";

    const vm = {
      image: image,
      identification: identificaton,
    };

    const vmWithoutImage = {
      name: "Bez Průkazu",
      surname: `(${identificaton}) Pacient`,
      withoutCard: isWithoutCard,
      identification: identificaton,
    };

    return isWithoutCard ? vmWithoutImage : vm;
  }

  async function getPhoto() {
    console.log(new Date().toISOString(), "getPhoto() from rpi", state);

    try {
      let { data } = await TerminalAppService.getPhoto(axiosTerminalAppInstance);
      //console.log(data);

      if (!data.isError) {
        console.log("spoustim registraci");
        registerPatient(data.data.image, false);
      } else {
        console.log("Chyba při získávání fotografie", data.message);
        handleSend(ACTION_GET_PHOTO_ERROR);
      }
    } catch (ex) {
      console.log("Chyba při získávání fotografie", ex);
      handleSend(ACTION_GET_PHOTO_ERROR);
    }
  }

  async function setCardReaderTo(state, from = "") {
    //console.log("card reader");
    try {
      let { data } = await TerminalAppService.setCardReaderTo(axiosTerminalAppInstance, state);
      if (!data.isError) {
        console.log("card reader set to:", state, from);
      } else {
        console.log("Chyba při nastaveni Card reader", data.message);
      }
    } catch (ex) {
      console.log("Chyba při nastaveni Card reader", ex);
    }
  }

  //test

  async function handleMqttMessage(newMessage) {
    //console.log("handleMqttMessage", newMessage, lastProcessedMessage);

    //nezpracovavat stejnou message vicekrat
    if (lastProcessedMessage !== newMessage) {
      setLastProcessedMessage(newMessage);
      console.log(new Date().toISOString(), "handleMqttMessage", newMessage, state);

      // Speciální logika pro téma RPi
      if (newMessage?.topic === Const.TOPIC_MQTTT_LOCAL) {
        if (newMessage.payload === Const.LOCAL_MESSAGE_CARD_INSERTED) {
          //po chybe a zobrazeni dialogu chci po vytazeni kartickya naslednem vlozeni jit hned do stavu STATE_DATA_PROCCESSING
          // co vola ACTION_INSERT ale volani ACTION_INSERT dat nemuzu muzu pouzit novy stav po ACTION_INSERT coz je STATE_DATA_PROCCESSING
          if (isDialogOpen) {
            reset(STATE_DATA_PROCCESSING);
          } else {
            handleSend(ACTION_INSERT, false);
          }

          if (isScreenSaverActive) {
            setScreenSaverActive(false);
            handleScreenSaverShowOrHide(false);
            console.log("handleMqttMessage ScreenSaver is active - set to active false");
          }

          await setCardReaderTo(Const.STATE_DISABLED, "LOCAL_MESSAGE_CARD_INSERTED");
          console.log("Detekce karty! Spouštím progress.", state);
          // Zde můžete volat další callback nebo funkci, pokud ji Hook přijímá.
        } else if (newMessage.payload === Const.LOCAL_MESSAGE_PHOTO_CREATED) {
          getPhoto();
        } else if (newMessage.payload === Const.LOCAL_MESSAGE_CARD_REMOVED_TOO_EARLY_ERROR) {
          handleSend(ACTION_CARD_REMOVED_TOO_EARLY_ERROR);
          console.log("Průkaz vytažen příliš brzo", state);
        } else if (newMessage.payload === Const.LOCAL_MESSAGE_CARD_REMOVED) {
          handleSend(ACTION_CARD_REMOVED);
          console.log("Průkaz vytažen ok", state);
        } else if (newMessage.payload === Const.LOCAL_MESSAGE_PHOTO_ERROR) {
          handleSend(ACTION_ERROR);
          initStateAfterCaptureOrError();
          console.log("Chyba při focení", state);
        }
      }
    }
  }

  async function handleStateChange(newState) {
    //nezpracovavat stejny state vicekrat
    if (lastProcessedState !== newState) {
      setLastProcessedState(newState);
      //console.log(new Date().toISOString(), "handleStateChange", newState);

      if (newState === STATE_RUNING_WITHOUT_CARD) {
        await registerPatient(null, true);
      } else {
        //v pripade ze se zmeni stav na chybu nastavi se ze je zobrazen dialog setDialogOpen(true);
        switch (newState) {
          case STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR:
          case STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR:
          case STATE_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED:
          case STATE_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED:
          case STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_ID:
          case STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_DL:
          case STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR:
          case STATE_CARD_REMOVED_TOO_EARLY:
          case STATE_API_PATIENT_REGISTRATION_ERROR:
          case STATE_GET_PHOTO_ERROR:
          case STATE_PHOTO_CAPTURE_ERROR:
            setDialogOpen(true);
            break;
        }
      }
    }
  }

  async function handleSend(state, withCardReaderEnabled = true) {
    if (withCardReaderEnabled) {
      await setCardReaderTo(Const.STATE_ENABLED, "handleSend");
    }
    send(state);
  }

  async function handleScreenSaverShowOrHide(showScreenSaver) {
    //console.log("terminalSettingsState:", terminalSettingsState);

    if (terminalSettingsState?.isBrightnessAdjustmentEnabled) {
      const max = terminalSettingsState?.brightnessMax ?? 255; //max possible val
      const min = terminalSettingsState?.brightnessMin ?? 0;
      const state = showScreenSaver ? Const.STATE_MIN : Const.STATE_MAX;
      console.log(
        `handleScreenSaverShowOrHide showScreenSaver:${showScreenSaver} setBrightnessTo ${state === Const.STATE_MAX ? "MAX" : "MIN"} max:${max}, min:${min}`,
      );

      await setBrightnessTo(state, max, min);
    }
  }

  //console.log(new Date().toISOString(), state);

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  //console.log("pageInsertCard isScreenSaverActive", isScreenSaverActive);

  return (
    <>
      <div className="flex flex-col h-dvh overflow-hidden">
        <div className="flex-1 overflow-y-scroll overflow-x-hidden">
          {!isScreenSaverActive && (
            <Navbar customTitle={title} customSubtitle={subtitle} modeShowTitle={true} modeShowSubtitle={showSubtitle} useCustomTitle={true} />
          )}
          {Const.isDebugMode() && <p className={`${getCssFor("debug-state-title")} absolute left-2 bottom-2 text-white text-center mt-4`}>State: {state}</p>}
          {isPhotoCaptureTestEnabled && (
            <p className={`${getCssFor("photo-capture-test-title")} absolute right-2 bottom-2 text-white text-center mt-4`}>
              Mód: {insert_card_photo_capture_test}
            </p>
          )}
          <Transition exit="none" initial="none">
            {state === STATE_CHANGE_DOCUMENT_OPENED && (
              <div>
                <h1 className={`${getCssFor("doc-h1")}  text-accent  text-center`}>{subtitle}</h1>
                <div className={`${getCssFor("doc-btn-grid")} grid ${docGridColumns}`}>
                  <button
                    className={`justify-items-center p-8 rounded-xl transition-colors ${isInsuranceCardBtnPressed ? "bg-accent-dark" : ""}`}
                    onClick={() => handleSetDocType(Const.DOC_TYPE_INSURANCE_CARD)}
                  >
                    <img src="/img/anim/insurance_card_512.png" className={`${getCssFor("doc-btn-image")} object-contain`} />
                    <div>
                      <p className={`${getCssFor("doc-p-title")} text-secondary font-light text-center`}>Kartička</p>
                      <p className={`${getCssFor("doc-p-subtitle")} text-secondary font-light text-center`}>pojištěnce</p>
                    </div>
                  </button>
                  {terminalSettingsState.isIDCardEnabled && (
                    <button
                      className={`select-none justify-items-center p-8 rounded-xl transition-colors ${isIdBtnPressed ? "bg-accent-dark" : ""}`}
                      onClick={() => handleSetDocType(Const.DOC_TYPE_ID)}
                    >
                      <img src="/img/anim/op_512.png" className={`${getCssFor("doc-btn-image")} object-contain`} />
                      <div>
                        <p className={`${getCssFor("doc-p-title")} text-secondary font-light text-center`}>Občanský</p>
                        <p className={`${getCssFor("doc-p-subtitle")} text-secondary font-light text-center`}>průkaz</p>
                      </div>
                    </button>
                  )}

                  {terminalSettingsState.isDrivingLicenceEnabled && (
                    <button
                      className={`select-none justify-items-center p-8 rounded-xl transition-colors ${isDlBtnPressed ? "bg-accent-dark" : ""}`}
                      onClick={() => handleSetDocType(Const.DOC_TYPE_DRIVER_LICENCE)}
                    >
                      <img src="/img/anim/dl_512.png" className={`${getCssFor("doc-btn-image")} object-contain`} />
                      <div>
                        <p className={`${getCssFor("doc-p-title")} text-secondary font-light text-center`}>Řidičský</p>
                        <p className={`${getCssFor("doc-p-subtitle")} text-secondary font-light text-center`}>průkaz</p>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            )}

            <div>
              {state === STATE_IDLE && (
                <>
                  <ScreenSaver
                    onActive={setScreenSaverActive}
                    onShow={() => handleScreenSaverShowOrHide(true)}
                    onHide={() => handleScreenSaverShowOrHide(false)}
                    isActive={isScreenSaverActive}
                  />

                  {!isScreenSaverActive && (
                    <>
                      {(terminalSettingsState.isDrivingLicenceEnabled || terminalSettingsState.isIDCardEnabled) && (
                        <div className="absolute top-1/2">
                          <Button
                            type="terminal-dark"
                            className={`${getCssFor("idle-doc-button")}  text-left -translate-y-1/2 rounded-none`}
                            title="Změnit průkaz totožnosti"
                            onClick={() => openChangeDocument()}
                          />
                        </div>
                      )}

                      <h1 className={`${getCssFor("idle-subtitle")} text-accent text-center`}>{page.subtitle}</h1>
                      <div className={`${getCssFor("idle-animation-div")} container mx-auto`}>
                        <ImageCardAnimation docType={docType} />
                      </div>
                    </>
                  )}
                </>
              )}
              {state === STATE_DATA_PROCCESSING && (
                <>
                  <ScaleSpinnerProgressSection
                    title={insert_card_title}
                    subTitle={insert_card_do_not_remove_card}
                    footerTitle={insert_card_not_have_card_progress_subtitle}
                  />
                </>
              )}

              {state === STATE_RUNING_WITHOUT_CARD && (
                <ScaleSpinnerProgressSection title={insert_card_title} footerTitle={insert_card_not_have_card_progress_subtitle} />
              )}

              {/* {state === STATE_API_PATIENT_REGISTRATION_SUCCES && (
                <Dialog title="Registrace pacienta do API" message={"proběhla úspěšně"} onClick={() => initStateAfterCaptureOrError()} />
              )} */}

              {(state === STATE_API_PATIENT_REGISTRATION_ERROR || state === STATE_GET_PHOTO_ERROR || state === STATE_PHOTO_CAPTURE_ERROR) && (
                <Dialog
                  buttonText="Zavřít a Opakovat"
                  type="error"
                  title={e_get_photo_dialog_title}
                  message={e_get_photo_dialog_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_CARD_REMOVED_TOO_EARLY && (
                <Dialog
                  buttonText="Zavřít a Opakovat"
                  type="error"
                  title={e_insert_card_removed_before_end_title}
                  message={e_insert_card_removed_before_end}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR && (
                <Dialog
                  buttonText="Zavřít a Opakovat"
                  type="error"
                  title={e_post_patient_406_dialog_title}
                  message={e_post_patient_406_dialog_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_DL && (
                <Dialog
                  buttonText="Zavřít a Opakovat"
                  type="error"
                  title={e_post_patient_406_dialog_driving_licence_title}
                  message={e_post_patient_406_dialog_driving_licence_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_PATIENT_REGISTRATION_ROTATION_406_ERROR_ID && (
                <Dialog
                  buttonText="Zavřít a Opakovat"
                  type="error"
                  title={e_post_patient_406_dialog_id_title}
                  message={e_post_patient_406_dialog_id_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_REGISTER_PATIENT_406_ERROR_ID_DISABLED && (
                <Dialog
                  buttonText="Zavřít"
                  type="error"
                  title={e_post_patient_id_diabled_title}
                  message={e_post_patient_id_diabled_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_REGISTER_PATIENT_406_ERROR_DL_DISABLED && (
                <Dialog
                  buttonText="Zavřít"
                  type="error"
                  title={e_post_patient_driving_licence_diabled_title}
                  message={e_post_patient_driving_licence_diabled_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_PATIENT_REGISTRATION_CONFLICT_409_ERROR && (
                <Dialog
                  buttonText="Zavřít"
                  type="info"
                  title={e_post_patient_409_dialog_title}
                  message={e_post_patient_409_dialog_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
              {state === STATE_API_PATIENT_REGISTRATION_CONNECTION_ERROR && (
                <Dialog
                  buttonText="Zavřít"
                  type="error"
                  title={e_post_patient_retry_failed_dialog_title}
                  message={e_post_patient_retry_failed_dialog_desc}
                  handleStateChange={setDialogOpen}
                  onClick={() => initStateAfterCaptureOrError()}
                />
              )}
            </div>

            {/* {showProgress && <ProgressSection title={"Probíhá registrace"} subTitle={"Probíhá registrace do systému, chviličku strpení..."} />} */}
          </Transition>
        </div>

        <footer className="">
          <div className="grid place-content-center">
            <div className="col-span-3 w-full mb-4">
              {state === STATE_IDLE && terminalSettingsState.isWithoutCardEnabled && !isScreenSaverActive && (
                <Button
                  type="terminal-dark"
                  title="Nemám průkaz"
                  className={`${getCssFor("idle-no-card-button")}   rounded-none`}
                  showIcon={false}
                  onClick={() => runPatientWihhoutCardClicked()}
                />
              )}
              {state === STATE_CHANGE_DOCUMENT_OPENED && (
                <Button
                  type="terminal-dark"
                  title="Zavřít"
                  className={`${getCssFor("doc-close-button")}  rounded-none`}
                  showIcon={false}
                  onClick={() => handleSetDocType(docType, false, false)}
                />
              )}
            </div>
          </div>
        </footer>

        {isTerminal && <HiddenMenuBar />}
      </div>
    </>
  );
}

export default PageInsertCard;
